!function (e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"));else if ("function" === typeof define && define.amd) define(["react"], t);else {
    var r = "object" === typeof exports ? t(require("react")) : t(e.react);
    for (var o in r) ("object" === typeof exports ? exports : e)[o] = r[o];
  }
}(this, function (e) {
  return function (e) {
    var t = {};
    function r(o) {
      if (t[o]) return t[o].exports;
      var n = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, o) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, r.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) r.d(o, n, function (t) {
        return e[t];
      }.bind(null, n));
      return o;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/ElllGeeEmm/react-lock-scroll/", r(r.s = 1);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    e.exports = r(2);
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var o = r(0);
    t.default = function () {
      for (var e = !0, t = !1, r = !1, n = arguments.length, f = new Array(n), u = 0; u < n; u++) f[u] = arguments[u];
      f.forEach(function (o) {
        "boolean" === typeof o ? e = o : o.hasOwnProperty("current") ? t = o : "object" == typeof o && (r = o);
      }), Object(o.useEffect)(function () {
        var o = t ? t.current : document.body;
        if (o) {
          if (o.style.overflow = e ? "hidden" : "", r) Object.keys(r).forEach(function (t) {
            o.style[t] = e ? r[t] : "";
          });
          return function () {
            (o.style.overflow = "", r) && Object.keys(r).forEach(function (e) {
              o.style[e] = "";
            });
          };
        }
      }, [e, t, r]);
    };
  }]);
});